import Tracker from "./tracker.js";

class TrackerSet {
    constructor(trackers) {
        this._trackers = trackers;
    }

    *[Symbol.iterator]() {
        yield* this._trackers[Symbol.iterator]();
    }
}

class TrackerGroup extends Tracker {
    constructor() {
        super();

        this._trackers = new Set();
        this._trackersNeedUpdate = new Set();
        this._removedTrackers = new Set();

        this._trackerNeedsUpdate = (tracker) => {
            this.protected_needsUpdate();
            this._trackersNeedUpdate.add(tracker);
        };

        this._updateTrackers = new TrackerSet(this._trackersNeedUpdate);

        this._trackData = Object.freeze(Object.defineProperties({}, {
            trackers: { get: () => this._updateTrackers, enumerable: true },
        }));
    }

    add(tracker) {
        this._trackers.add(tracker);
        this._trackerNeedsUpdate(tracker);
        this._removedTrackers.delete(tracker);

        tracker.listenNeedsUpdate(this._trackerNeedsUpdate);
    }

    remove(tracker) {
        this._trackerNeedsUpdate(tracker);
        this._removedTrackers.add(tracker);

        tracker.unlistenNeedsUpdate(this._trackerNeedsUpdate);
    }

    protected_startUpdate() {
        return this._trackData;
    }

    protected_finishUpdate() {
        this._trackersNeedUpdate.clear();

        for (const tracker of this._removedTrackers) {
            this._trackers.delete(tracker);
        }

        this._removedTrackers.clear();
    }
}

export default TrackerGroup;
